import { useQuery } from '@apollo/client';
import {
  MostQueriesDocument,
  MostQueriesQuery,
} from 'src/graphql/generated/graphql';

export const useMostQueries = () => {
  const { data, loading } = useQuery<MostQueriesQuery>(MostQueriesDocument, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only',
  });

  return {
    data: data?.mostQueries,
    loading,
  };
};
